import { render } from "./Play.vue?vue&type=template&id=0479546b&scoped=true"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"

import "./Play.vue?vue&type=style&index=0&id=0479546b&lang=less&scoped=true"
import "./Play.vue?vue&type=style&index=1&id=0479546b&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0479546b"]])

export default __exports__